/* import __COLOCATED_TEMPLATE__ from './project-completion-public-feedback.hbs'; */
import { equal, alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { PROJECT_COMPLETION__SUB_VIEWS } from 'sh-www/constants/routes/project-completion';
import { LSG_REVIEW_STARS__STAR_LABELS } from "../lsg/lsg-reviews-stars";
import { EMBER_ROUTE_NAMES } from "../../constants/routes";

/**
 * This will show the public feedback section for the project completion flow
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-project-completion-public-feedback'],
  classNameBindings: [
    '_isShowPublicFeedback::hide'
  ],

  /**
   * Register services
   */
  applicationStateManager: service('state-managers/application'),
  state: service('states/routes/project-completion'),
  stateManager: service('state-managers/routes/project-completion'),
  router: service(),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _isMarkProjectCompleteDisabled: computed(
  'state.hasEnteredAllPublicFeedback',
  'stateManager.submitPublicFeedbackBuyer.isRunning',
  function() {
    if (!this.get('state.hasEnteredAllPublicFeedback')) {
      return true;
    }

    return this.stateManager.submitPublicFeedbackBuyer.isRunning;
  }),

  /**
   * @type {Boolean}      True if we want to show this component.
   */
  _isShowPublicFeedback: equal('state.subView', PROJECT_COMPLETION__SUB_VIEWS.PUBLIC_FEEDBACK),

  /**
   * @type {Array<String>}    List of strings we will send the to stars component to show when buyer selects a review rating.
   */
  _ratingTextLabels: LSG_REVIEW_STARS__STAR_LABELS,

  /**
   * The text message for the review.
   *
   * NOTE --- ALIASED TO TOP LEVEL ROUTE STATE!
   *
   * @type {String}
   */
  _reviewTextMessage: alias('state.reviewTextMessage'),

  actions: {
    /**
     *
     */
    onBackClicked: function() {
      this.stateManager.setSubView(PROJECT_COMPLETION__SUB_VIEWS.NONE);

      this.get('applicationStateManager').setNextRoute(
        EMBER_ROUTE_NAMES.PROJECT__COMPLETE,
        null,
        this.get('state.application.id'));
    },

    /**
     *
     */
    onMarkProjectCompletedClicked: function() {
      if (this.get('state.isBuyerViewing')) {
        const lastTaskWasError = this.stateManager.submitPublicFeedbackBuyer.last?.isError;
        this.get('stateManager.submitPublicFeedbackBuyer').perform().then(() => {
          this.get('applicationStateManager').setNextRoute(
            EMBER_ROUTE_NAMES.PROJECT__COMPLETE__PRIVATE_FEEDBACK,
            null,
            this.get('state.application.id'));
        })
        .catch(() => {
          if (lastTaskWasError) {
            this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS, this.state.application.id);
          }
        });
      }
    },

    /**
     * @param {Number} starCountSelected
     */
    onStarClick: function(starCountSelected) {
      this.get('stateManager').updateReviewStarCountSelected(starCountSelected + 1);
    }
  }
});
